// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"d30f3e42","598":"869e9892"}[chunkId] + ".chunk.js";
};